<template>
  <button
    v-show="cartStore.storeCartItemCount > 0"
    type="button"
    :class="triggerButtonClass"
    @click="openCart"
  >
    <span class="sr-only">
      {{ $t('commerce.storeCartTrigger.viewCart') }}
    </span>

    <ShoppingCartIcon
      :class="triggerIconClass"
      aria-hidden="true"
    />

    <span
      v-if="cartStore.storeCartItemCount > 0"
      :class="triggerBadgeClass"
    >
      {{ cartStore.storeCartItemCount }}
    </span>
  </button>
</template>

<script setup lang="ts">
import { ShoppingCartIcon } from '@heroicons/vue/24/outline'
import { useCartStore } from '~/stores/useCartStore'

const props = withDefaults(
  defineProps<{
    /** Classes applied to the trigger button. */
    triggerButtonClass?: string

    /** Classes applied to the draft-order count badge. */
    triggerBadgeClass?: string

    /** Classes applied to the trigger icon. */
    triggerIconClass?: string
  }>(),
  {
    triggerBadgeClass:
      'absolute right-0 top-0 flex h-5 min-w-5 items-center justify-center rounded-full bg-primary px-1 text-xs font-medium leading-none text-content-inverse shadow-sm',
    triggerButtonClass:
      'relative inline-flex size-10 items-center justify-center rounded-full text-content-level-500 transition-colors hover:bg-surface-level-100 hover:text-content-level-700 dark:text-content-level-400 dark:hover:bg-surface-canvas/5 dark:hover:text-content-inverse cursor-pointer',
    triggerIconClass: 'h-5 w-5'
  }
)

const cartStore = useCartStore()

const triggerButtonClass = computed(() => props.triggerButtonClass)
const triggerIconClass = computed(() => props.triggerIconClass)
const triggerBadgeClass = computed(() => props.triggerBadgeClass)

const openCart = () => {
  cartStore.openStoreCart()
}
</script>
